import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import Icon from '../../components/AppIcon';

const RassegnaStampa = () => {
  // Array loghi rassegna con URL esterni Imgur (LG1-LG18, con LG5/LG9/LG19 null)
  const loghiRassegna = [
    'https://i.imgur.com/2SIXHI1.png', // LG1
    'https://i.imgur.com/Cv6BenI.png', // LG2
    'https://i.imgur.com/tYH43e8.png', // LG3
    'https://i.imgur.com/hgfStW4.png', // LG4
    'https://i.imgur.com/tBkAtlf.png', // LG5
    'https://i.imgur.com/xNx1KSy.png', // LG6
    'https://i.imgur.com/Ra57OWz.png', // LG7
    'https://i.imgur.com/lM2MCWr.png', // LG8
    'https://i.imgur.com/SwwaqUq.png', // LG9
    'https://i.imgur.com/Y7K27BA.png', // LG10
    'https://i.imgur.com/KeygsR9.png', // LG11
    'https://i.imgur.com/0nvOVYF.png', // LG12
    'https://i.imgur.com/Ch5SAJe.png', // LG13
    'https://i.imgur.com/bTPvz49.png', // LG14
    'https://i.imgur.com/WbtRz4y.png', // LG15
    'https://i.imgur.com/Uz4qNSQ.png', // LG16
    'https://i.imgur.com/LnzzAoz.png', // LG17
    'https://i.imgur.com/Ohe2qow.png', // LG18
    'https://i.imgur.com/TViZ8vc.png'  // LG19
  ];

  const testateLocali = [
    { name: 'Cronache Maceratesi', url: 'https://www.cronachemaceratesi.it', logo: loghiRassegna?.[0] },
    { name: 'Picchio News', url: 'https://www.picchionews.it', logo: loghiRassegna?.[3] },
    { name: 'Vivere Civitanova', url: 'https://www.viverecivitanova.it', logo: loghiRassegna?.[6] },
    { name: 'Il Resto del Carlino - Macerata', url: 'https://www.ilrestodelcarlino.it/macerata', logo: loghiRassegna?.[10] },
    { name: 'Macerata Notizie', url: 'https://www.maceratanotizie.it', logo: loghiRassegna?.[13] },
    { name: 'EMMETV', url: 'https://www.emmetv.it', logo: loghiRassegna?.[16] },
    { name: 'Centro Pagina', url: 'https://www.centropagina.it', logo: loghiRassegna?.[18] }
  ];

  const testateNazionali = [
    { name: 'Corriere della Sera', url: 'https://www.corriere.it', logo: loghiRassegna?.[1] },
    { name: 'La Repubblica', url: 'https://www.repubblica.it', logo: loghiRassegna?.[4] },
    { name: 'ANSA', url: 'https://www.ansa.it', logo: loghiRassegna?.[7] },
    { name: 'Il Sole 24 Ore', url: 'https://www.ilsole24ore.com', logo: loghiRassegna?.[8] },
    { name: 'Il Messaggero', url: 'https://www.ilmessaggero.it', logo: loghiRassegna?.[11] },
    { name: 'TGCOM24', url: 'https://www.tgcom24.mediaset.it', logo: loghiRassegna?.[14] }
  ];

  const testateSport = [
    { name: 'La Gazzetta dello Sport', url: 'https://www.gazzetta.it', logo: loghiRassegna?.[2] },
    { name: 'Tuttosport', url: 'https://www.tuttosport.com', logo: loghiRassegna?.[5] },
    { name: 'Sky Sport', url: 'https://sport.sky.it', logo: loghiRassegna?.[9] },
    { name: 'Eurosport Italia', url: 'https://www.eurosport.it', logo: loghiRassegna?.[12] },
    { name: 'Sport Mediaset', url: 'https://www.sportmediaset.mediaset.it', logo: loghiRassegna?.[15] },
    { name: 'Corriere dello Sport', url: 'https://www.corrieredellosport.it', logo: loghiRassegna?.[17] }
  ];

  const NewsCard = ({ name, url, logo }) => {
    const [imageError, setImageError] = useState(false);
    const [imageLoaded, setImageLoaded] = useState(false);

    return (
      <a
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        className="bg-white border-2 border-gray-200 rounded-lg p-6 transition-all duration-300 hover:border-primary hover:shadow-lg hover:scale-105 flex items-center gap-4 group"
      >
        <div className="w-16 h-12 bg-white rounded-lg flex items-center justify-center flex-shrink-0 border border-gray-200 overflow-hidden">
          {logo && !imageError ? (
            <>
              {!imageLoaded && (
                <div className="w-[72px] h-[28px] bg-gray-200 animate-pulse rounded" />
              )}
              <img
                src={logo}
                alt={`Logo ${name}`}
                className={`h-7 w-auto object-contain transition-opacity duration-300 ${
                  imageLoaded ? "opacity-100" : "opacity-0 absolute"
                }`}
                height="28"
                loading="lazy"
                decoding="async"
                onLoad={() => setImageLoaded(true)}
                onError={() => {
                  setImageError(true);
                  setImageLoaded(false);
                }}
              />
            </>
          ) : (
            <Icon name="Newspaper" size={22} color="var(--color-primary)" />
          )}
        </div>
        <span className="text-[17px] font-semibold text-gray-900 group-hover:text-primary transition-colors">
          {name}
        </span>
      </a>
    );
  };

  return (
    <>
      <Helmet>
        <title>Rassegna Stampa - Cliccami.net</title>
        <meta
          name="description"
          content="Consulta quotidianamente le notizie dal territorio, dallo sport e dall'attualità nazionale, accedendo direttamente alle principali testate giornalistiche."
        />
      </Helmet>
      <div className="min-h-screen bg-background">
        <Header onFilterClick={() => {}} />

        {/* Back to Services Button */}
        <div className="max-w-7xl mx-auto px-4 md:px-6 pt-6">
          <a 
            href="https://app.cliccami.net/#/home-servizi"
            className="inline-flex items-center gap-2 bg-white border border-gray-200 rounded-lg px-4 py-2 font-semibold text-gray-700 hover:text-primary hover:border-primary transition-all duration-300"
          >
            <Icon name="ArrowLeft" size={18} />
            Torna ai Servizi
          </a>
        </div>

        {/* Hero Section */}
        <section 
          className="pt-24 pb-12 relative overflow-hidden"
          style={{
            backgroundImage: 'url(https://images.unsplash.com/photo-1526779259212-939e64788e3c?auto=format&fit=crop&w=2400&q=80)',
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}
        >
          {/* White overlay with blur */}
          <div className="absolute inset-0 bg-white/70 backdrop-blur-[2px]"></div>
          
          <div className="max-w-7xl mx-auto px-4 md:px-6 relative z-10">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Le notizie della città, ogni giorno
            </h1>
            <p className="text-lg md:text-xl text-gray-700 leading-relaxed max-w-4xl">
              Consulta quotidianamente le notizie dal territorio, dallo sport e dall'attualità nazionale, accedendo direttamente alle principali testate giornalistiche.
            </p>
          </div>
        </section>

        {/* Main Content - 3 Sections */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
              {/* Testate Locali */}
              <div className="space-y-6">
                <div className="mb-6">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-9 h-9 bg-gray-100 rounded-lg flex items-center justify-center">
                      <Icon name="MapPin" size={22} color="var(--color-primary)" strokeWidth={1.5} />
                    </div>
                    <h2 className="text-xl md:text-2xl font-semibold text-gray-900 tracking-tight">
                      Testate Locali
                    </h2>
                  </div>
                  <div className="h-px bg-gray-200 mt-3"></div>
                </div>
                <div className="space-y-4">
                  {testateLocali?.map((testata) => (
                    <NewsCard key={testata?.name} name={testata?.name} url={testata?.url} logo={testata?.logo} />
                  ))}
                </div>
              </div>

              {/* Testate Nazionali */}
              <div className="space-y-6">
                <div className="mb-6">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-9 h-9 bg-gray-100 rounded-lg flex items-center justify-center">
                      <Icon name="Globe" size={22} color="var(--color-primary)" strokeWidth={1.5} />
                    </div>
                    <h2 className="text-xl md:text-2xl font-semibold text-gray-900 tracking-tight">
                      Testate Nazionali
                    </h2>
                  </div>
                  <div className="h-px bg-gray-200 mt-3"></div>
                </div>
                <div className="space-y-4">
                  {testateNazionali?.map((testata) => (
                    <NewsCard key={testata?.name} name={testata?.name} url={testata?.url} logo={testata?.logo} />
                  ))}
                </div>
              </div>

              {/* Sport */}
              <div className="space-y-6">
                <div className="mb-6">
                  <div className="flex items-center gap-3 mb-3">
                    <div className="w-9 h-9 bg-gray-100 rounded-lg flex items-center justify-center">
                      <Icon name="Trophy" size={22} color="var(--color-primary)" strokeWidth={1.5} />
                    </div>
                    <h2 className="text-xl md:text-2xl font-semibold text-gray-900 tracking-tight">
                      Sport
                    </h2>
                  </div>
                  <div className="h-px bg-gray-200 mt-3"></div>
                </div>
                <div className="space-y-4">
                  {testateSport?.map((testata) => (
                    <NewsCard key={testata?.name} name={testata?.name} url={testata?.url} logo={testata?.logo} />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default RassegnaStampa;